import { AppNotificationCategory } from '../types/appNotifications';

export const APP_NOTIFICATION_CATEGORY_LABELS = {
  [AppNotificationCategory.general]: 'Generales',
  [AppNotificationCategory.security]: 'Seguridad',
  [AppNotificationCategory.logistics]: 'Logística',
  [AppNotificationCategory.management]: 'Gestión',
  [AppNotificationCategory.video_system]: 'Sistema Video',
  [AppNotificationCategory.road_vision]: 'V. Camino',
  [AppNotificationCategory.driver_vision]: 'V. Conductor',
  [AppNotificationCategory.identification_vision]: 'V. Identificación',
};
